import { BaseState } from '@/store/base-state';
import { Organizations } from '@/modules/organizations/types';

export default class OrganizationCheckState extends BaseState {
  search_orgs: Organizations.OrganizationCheck[] = [];
  search_orgs_loading = false;
}
